import React from "react";
import { Link } from "react-router-dom";
import {
  Briefcase,
  FileText,
  PlusCircle,
  Users,
  BarChart2,
} from "lucide-react";

const QuickActionCard = ({ title, description, icon, linkTo }) => (
  <Link
    to={linkTo}
    className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center hover:shadow-lg transition-shadow"
  >
    <div className="text-blue-500 mb-4">{icon}</div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </Link>
);

const QuickActions = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Quick Actions</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <QuickActionCard
          title="Manage Job Listings"
          description="View, edit, and delete job postings"
          icon={<Briefcase className="w-12 h-12" />}
          linkTo="/admin/job-listings"
        />
        <QuickActionCard
          title="Review Applications"
          description="Process and manage candidate applications"
          icon={<FileText className="w-12 h-12" />}
          linkTo="/admin/applications"
        />
        <QuickActionCard
          title="Post New Job"
          description="Create and publish a new job listing"
          icon={<PlusCircle className="w-12 h-12" />}
          linkTo="/post-job"
        />
        <QuickActionCard
          title="Manage Users"
          description="View and manage user accounts"
          icon={<Users className="w-12 h-12" />}
          linkTo="/admin/users"
        />
        <QuickActionCard
          title="View Analytics"
          description="Access detailed job and application analytics"
          icon={<BarChart2 className="w-12 h-12" />}
          linkTo="/admin/analytics"
        />
      </div>
    </div>
  );
};

export default QuickActions;
